module.exports = __webpack_public_path__ + "static/media/greenPic.f7081a96.jpg";